var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-page"}},[_c('div',{staticClass:"loghi-container"},[_c('img',{attrs:{"alt":_vm.$t('error-page.logo'),"id":"logo","src":require("./../assets/logo.png")}})]),_c('img',{attrs:{"alt":_vm.$t('error-page.page-not-found'),"id":"page_not_found","src":require("./../assets/404.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }